/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import axios from 'axios';

import { endpoints } from '../../ia/util/config';

export const checkCredentials = async (
  assistantId: string,
  url: string,
  username: string,
  password: string,
  port?: string
): Promise<any> => {
  const response = await axios.post(
    `${endpoints.store}/milvus/credentials`,
    {
      assistantId,
      url,
      username,
      password,
      port
    },
    {
      headers: { 'content-type': 'application/json' }
    }
  );

  return response?.data;
};

export const listDataSources = async (
  skillId: string,
  assistantId: string,
  url: string,
  username: string,
  password: string,
  port?: string
): Promise<any> => {
  const response = await axios.post(
    `${endpoints.store}/milvus/datasources`,
    {
      skillId,
      assistantId,
      url,
      username,
      password,
      port
    },
    {
      headers: { 'content-type': 'application/json' }
    }
  );

  return response?.data;
};

export const listCollections = async (
  skillId: string,
  assistantId: string,
  url: string,
  database: string,
  username: string,
  password: string,
  port?: string
): Promise<any> => {
  const response = await axios.post(
    `${endpoints.store}/milvus/collections`,
    {
      skillId,
      assistantId,
      url,
      database,
      username,
      password,
      port
    },
    {
      headers: { 'content-type': 'application/json' }
    }
  );

  return response?.data;
};

export const getIndices = async (
  skillId: string,
  assistantId: string,
  url: string,
  database: string,
  collectionName: string,
  username: string,
  password: string,
  port?: string
): Promise<any> => {
  const response = await axios.post(
    `${endpoints.store}/milvus/indices`,
    {
      skillId,
      assistantId,
      url,
      database,
      collectionName,
      username,
      password,
      port
    },
    {
      headers: { 'content-type': 'application/json' }
    }
  );

  return response?.data;
};

export const getFields = async (
  skillId: string,
  assistantId: string,
  url: string,
  database: string,
  collectionName: string,
  username: string,
  password: string,
  port?: string
): Promise<any> => {
  const response = await axios.post(
    `${endpoints.store}/milvus/fields`,
    {
      skillId,
      assistantId,
      url,
      database,
      collectionName,
      username,
      password,
      port
    },
    {
      headers: { 'content-type': 'application/json' }
    }
  );

  return response?.data;
};
